module.exports = __webpack_public_path__ + "img/icon-search.2a00f365.svg";